import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconFlightTakeoff } from '@travel-frontend/icons';
import { Container } from '../../../components/FlightDetails/Header/components/Container.js';
import { Content } from '../../../components/FlightDetails/Header/components/Content.js';
import { Icon } from '../../../components/FlightDetails/Header/components/Icon.js';
import { TextWrapper } from '../../../components/FlightDetails/TextWrapper.js';
import { LabelSmall, LabelXLargeBold } from '../../../primitives/index.js';
import { FLIGHT_DETAILS_QA_ID, qaId } from '../../../utils/qaId.js';
export const Header = ({
  direction,
  title,
  date,
  alert = false,
  highlightDate = false
}) => {
  return _jsxs(Container, {
    "data-testid": qaId(FLIGHT_DETAILS_QA_ID, `${direction}flight-header`),
    children: [_jsx(Icon, {
      rotate: direction === 'inbound',
      children: _jsx(IconFlightTakeoff, {})
    }), _jsxs(Content, {
      alert: alert,
      children: [_jsx(LabelXLargeBold, {
        children: title
      }), _jsx(LabelSmall, {
        "data-testid": "shared-flightLayer-flightDate",
        color: "contentSecondary",
        children: _jsx(TextWrapper, {
          highlighted: highlightDate,
          children: date
        })
      })]
    })]
  });
};